import { LevelSnapshot } from 'app/agriculture/queries/devices/types/LevelSnapshot';
import { Device } from 'app/agriculture/queries/devices/types/Device';

export function validateLevelSnapshot(
    levelSnapshot: LevelSnapshot | null,
    { device }: { device: Device },
): LevelSnapshot | null {
    if (!levelSnapshot) return null;
    if (levelSnapshot.infrastructureId == null) return null;
    if (device.infrastructureId == null) return null;
    if (levelSnapshot.infrastructureId !== device.infrastructureId) return null;

    return levelSnapshot;
}
